import axios from 'axios';
import { urlsServices } from '@/config/urls';

let httpUrl = `${urlsServices.GETWAY}api/pista-corrida`;
export const create = async (alimento) => {
  return await axios.post(`${httpUrl}/create`, alimento).then((response) => response);
};

export const getLista = async (filtros) => {
  return await axios.post(`${httpUrl}/listByFiltros`, filtros).then((response) => response);
};

export const getById = async (id) => {
  return await axios.get(`${httpUrl}/${id}`).then((response) => response);
};

export const deleteById = async (id) => {
  return await axios.delete(`${httpUrl}/${id}`).then((response) => response);
};
